<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate
      :openDialog="isOpen"
      :widthDialog="'400px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('closed')"
    >
      <template #body>
        <div>
          <h3 class="dialogTitle margin-left-0">Lưu trữ văn bản đến</h3>
        </div>
        <div class="content-delete">
          <label>Bạn chắc chắn muốn lưu trữ văn bản đến này? </label>
        </div>
      </template>

      <template #footer>
        <div class="flex-row flex__center form-button__action margin-top-10">
          <el-button
            type="success"
            size="mini"
            class="addDocs btn-none__border color__white bg__blue"
            @click="save"
          >
            <span class="flex-row flex__center">
              <i class="fas fa-save font-size__medium"></i>
              &nbsp;&nbsp;Lưu
            </span>
          </el-button>
          <el-button
            type="info"
            size="mini"
            class="btn__cancel btn-none__border"
            @click="cancel"
          >
            <span class="flex-row flex__center">
              <i class="far fa-times-circle font-size__medium"></i>
              &nbsp;&nbsp;Hủy
            </span>
          </el-button>
        </div>
      </template>
    </dialogTemplate>
  </div>
</template>

<script>
import goBackMixin from "../../mixins/goBackMixin";
export default {
  name: "dialog-delete",
  mixins: [goBackMixin],
  props: ["isOpen"],
  components: {
    dialogTemplate: () => import("../common/custom-dialog.vue"),
  },

  methods: {
    cancel() {
      this.$emit("closeDialog");
    },

    save() {
      this.$emit("saveDocIn");
    },
  },
};
</script>

<style scoped>
.content-delete {
  height: 75px;
  margin-top: 70px;
  color: #2d3e4f;
  font-size: 14px;
  text-align: center;
}

.dialogTitle {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/doc-in/acceptSaveDocIn.vue